<template>
  <div class="layoutTenant">
    <div class="layoutTenant-header pa-3">
      <slot name="header" />
    </div>
    <v-divider class="mt-2"/>
    <div class="layoutTenant-content pa-3 pt-4 white">
      <div class="layoutTenant-route">
        <slot />
      </div>
      <div class="layoutTenant-footer">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style>
  .layoutTenant {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .layoutTenant-content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
</style>
